module.exports = __webpack_public_path__ + "img/MFT白皮书_2.446927f8.jpg";